import Record from "../Record";
import ICustomFormSettings from "../../ICustomFormSettings";
import m, {Vnode} from "mithril";
import {LabelItem} from "../../../model/items/labelItem";
import {ImageItem} from "../../../model/items/imageItem";

export default class RecordImages extends Record {

    private readonly images: {label: string, image: string}[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);
        const layout = settings.form.grid.layout;
        const questionary = this.settings.form.questionary;

        for (let i=1; i<layout?.length; i++) {
            const label = <LabelItem|undefined>layout[i][0]?.cellItems[0];
            const image = <ImageItem|undefined>layout[i][1]?.cellItems.filter(c => c instanceof ImageItem)[0];

            if (image) {
                this.images.push({
                    label: label?.label || String(i),
                    image: questionary.getFileUrl(image.file),
                });
            }
        }
    }

    checkRequirements(): boolean {
        if (!this.images.length) {
            console.log('customForm-Record-images: Missing images.');
            return false;
        }

        return super.checkRequirements();
    }

    view(): Vnode {
        return this.viewLayout([
             m('.content-top', {}, [
                 Boolean(document.body.requestFullscreen) ? m(document.fullscreenElement ? 'i.icon.icon-close' : 'i.icon.icon-arrow-expand-all', {
                    onclick: (e: MouseEvent) => {
                        if (document.fullscreenElement) {
                            document.exitFullscreen?.().then(() => m.redraw());
                        } else {
                            $(<HTMLElement>e.currentTarget).closest('.content')[0].requestFullscreen?.().then(() => m.redraw());
                        }
                    },
                }) : null,
            ]),
            m('.content-middle.RecordImages', {}, [
                m('.items', {}, this.images.map(image => m('.item', {
                        onclick: (e: MouseEvent) => {
                            this.log(image.label)
                            window.navigator.vibrate?.(50);
                            const $item = $(<HTMLElement>e.currentTarget).addClass('magic-animation');
                            setTimeout(() => $item.removeClass('magic-animation'), 500);
                        },
                    }, m('img', {
                        draggable: false,
                        src: image.image,
                        title: image.label,
                    })))
                ),
            ]),
            m('.content-bottom'),
        ]);
    }

}
